export default {
  id: null,
  nome: null,
  plataforma: null,
  servico: null,
  situacao: null,
  dataEnvio: null,
  campanhaModeloId: null,
  campanhaHsmId: null,
  campanhaListaId: null,
  provedorId: null,
  observacao: null,
  iniciada: null,
  alias: null
}



// WEBPACK FOOTER //
// ./src/shared/models/campaign/campaignmodel.js